import { IconButton } from "@smartsuite/react-ui/lib/components/buttons/IconButton/IconButton";
import { Tooltip } from "@smartsuite/react-ui/lib/components/help/Tooltip/Tooltip";
import type { Placements } from "@smartsuite/react-ui/lib/components/help/Tooltip/Tooltip.constants";
import { GrayColors, type ID, SolutionColorVariables } from "@smartsuite/types";
import { useCallback } from "react";

export interface SearchRecordButtonProps {
  applicationId?: ID;
  totalRecords: number;
}

const tooltipPlacements: Placements = ["top"];

export const SearchRecordButton: React.FC<SearchRecordButtonProps> = ({
  applicationId,
  totalRecords,
}) => {
  const isDisabled = totalRecords === 0;

  const handleClick = useCallback((): void => {
    if (isDisabled || !applicationId) return;
    window.parent.postMessage(
      {
        type: "open-record-search",
        payload: {
          applicationId,
        },
      },
      "*",
    );
  }, [applicationId, isDisabled]);

  return (
    <div className="search-record-button">
      <Tooltip
        text="Search a Record"
        padding={2}
        placements={tooltipPlacements}
        disabled={isDisabled}
        target={
          <IconButton
            kind="round"
            name="search"
            size="S"
            color={isDisabled ? GrayColors["G-3"] : SolutionColorVariables.sc1}
            hoverColor={SolutionColorVariables.sc1}
            backgroundHoverColor={SolutionColorVariables.sc2}
            disabled={isDisabled}
            ariaLabel="Find a record from application"
            className="search-record-button__button"
            onClick={handleClick}
          />
        }
      />
    </div>
  );
};
